export const GOOGLE_TAG_GATEWAY_PATH = "/wfp9v3k7";
export const GOOGLE_TAG_GATEWAY_SCRIPT_PATH = `${GOOGLE_TAG_GATEWAY_PATH}/gtm.js`;

const GTM_CONTAINER_ID_PATTERN = /^GTM-[A-Z0-9]+$/;

export function getGoogleTagGatewayOrigin(): URL | null {
  const containerId = process.env["NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID"];

  if (!containerId || !GTM_CONTAINER_ID_PATTERN.test(containerId)) {
    return null;
  }

  return new URL(`https://${containerId.toLowerCase()}.fps.goog`);
}
